module.exports = __webpack_public_path__ + "img/route-46-cjd.68cfcf1e.png";